import React, { useEffect, useState } from 'react'
import classNames from 'classnames'

import CircleLoader from '@components/CircleLoader'

import { getActualSurvey, getAllSurveyAdmin, getSurveyResult } from '../../selectors'
import { getAllSurveysByCountryAdmin, getSurveyResultsById, clearSurveyResultsValue } from '../../actions'

import DetailsView from './DetailsView'

import styles from '../styles.module.scss'

const HistoryView = ({
    allSurvey,
    getAllSurveysByCountryAdmin,
    getSurveyResultsById,
    surveyResult,
    clearSurveyResultsValue,
}) => {
    const [currentSurvey, setCurrentSurvey] = useState(null)

    const showMainView = !currentSurvey

    const handleDetailsPageClick = survey => getSurveyResultsById(survey.surveyId)

    const onGoBackHandler = () => setCurrentSurvey(null)

    useEffect(() => {
        clearSurveyResultsValue()
        setCurrentSurvey(null)
        getAllSurveysByCountryAdmin()
    }, [])

    useEffect(() => {
        setCurrentSurvey(surveyResult)
    }, [surveyResult])

    return showMainView ? (
        <div>
            <div className={classNames('container', styles.npsContent)}>
                <h1 className={styles.npsContainerTitle}>
                    <T>nps.admin.main.menu.history.sectionHeading</T>
                </h1>
            </div>
            <div className={classNames('container', styles.npsHistoryTable)}>
                {allSurvey ? (
                    <div>
                        <div className={classNames('row border-bottom ', styles.npsHistoryTableHeader)}>
                            <div className="col px-0">
                                <T>nps.admin.history.table.name.label</T>
                            </div>
                            <div className="col px-0">
                                <T>nps.admin.history.table.date.start</T>
                            </div>
                            <div className="col px-0">
                                <T>nps.admin.history.table.date.end</T>
                            </div>
                            <div className="col px-0">
                                <T>nps.admin.history.table.total.answers</T>
                            </div>
                            <div className="col px-0"></div>
                        </div>
                        {allSurvey.map(survey => (
                            <div
                                className={classNames('row border-bottom ', styles.npsHistoryTableRow)}
                                key={survey.surveyId}>
                                <div className="col px-0 font-weight-bold">{survey.name}</div>
                                <div className="col px-0">{survey.dateStart}</div>
                                <div className="col px-0">{survey.dateEnd}</div>
                                <div className="col px-0">{survey.surveyAnswersCount}</div>
                                <div className="col px-0 text-right">
                                    <button
                                        type="button"
                                        className="btn btn-primary text-uppercase font-weight-bold"
                                        onClick={() => handleDetailsPageClick(survey)}>
                                        <T>nps.admin.history.details.button</T>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="d-flex pb-6 justify-content-center">
                        <CircleLoader size="small" />
                    </div>
                )}
            </div>
        </div>
    ) : (
        <DetailsView survey={currentSurvey} onClick={onGoBackHandler} />
    )
}

export default compose(
    connect(
        createStructuredSelector({
            allSurvey: getAllSurveyAdmin,
            actualSurvey: getActualSurvey,
            surveyResult: getSurveyResult,
        }),
        { getAllSurveysByCountryAdmin, getSurveyResultsById, clearSurveyResultsValue }
    )
)(HistoryView)
